import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";

import { AppLoader } from "~/components/layout/app-loader";
import { identify } from "~/libs/analytics";

export const Route = createFileRoute("/_auth")({
  component: withAuthenticationRequired(AuthLayout, {
    onRedirecting: AppLoader,
  }),
});

function AuthLayout() {
  const { user } = useAuth0();

  useEffect(() => {
    if (user) {
      const encoder = new TextEncoder();
      const data = encoder.encode(user.email);
      void window.crypto.subtle.digest("SHA-256", data).then((hash) => {
        const hashArray = Array.from(new Uint8Array(hash));
        const hashHex = hashArray
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("");
        identify(hashHex);
      });
    }
  }, [user]);

  return <Outlet />;
}
